import { Branch } from "@/model/data/Branch";
import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";
import { GetBranchesResData } from "./GetBranchesResData";

const ENDPOINT = "/branch";

export class EditBranchCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "put";

    params: Branch = null;

    constructor(branch: Branch) {
        super();
        this.params = branch;
    }

    public async execute(): Promise<GetBranchesResData> {
        var res = await this.executeCommand(this.params);
        return new GetBranchesResData(res);
    }
}
